import React, {useCallback} from 'react'
import {useLocation} from 'react-router-dom'
import {BucketInfo} from '../../../DTO/BucketInfoDTO'
import {MBMemberError} from '../../../Common/MBMemberError'
import {ExternalLinkButton} from '../../Atoms/Buttons'
import {CompleteMessageContent} from '../../Components/CompleteContentBlocks/CompleteMessageContent'
import {MembersPageTemplate} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import StepGuide from '../../Molecules/StepGuide/StepGuide'
import {Spacer} from '../../../../Common/Components/Spacer'
import {PIMPageActions} from '../../Atoms/Layouts/PIMPageActions'
import {NavigatorForMemberPage} from '../../../Navigator/NavigatorForMemberPage'

type MembersEditContractCompletePageProps = {
  navigator: NavigatorForMemberPage
}

type MembersEditContractCompletePageLocationState = {
  bucketInfo: BucketInfo
  nextContractStartDate?: string
}
export const MembersEditContractCompletePage: React.VFC<MembersEditContractCompletePageProps> = (
  {
    navigator,
  },
) => {
  const location = useLocation<MembersEditContractCompletePageLocationState>()
  const locationState: MembersEditContractCompletePageLocationState = location.state

  const handleCvsSelectLinkClick = useCallback((): void => {
    navigator.goToEditContractInfoPage(locationState.bucketInfo.key)
  }, [navigator, locationState])

  const isInvalidLocationState = (
    locationState: MembersEditContractCompletePageLocationState,
  ): boolean => {
    if (!locationState) {
      return true
    }
    if (!locationState.bucketInfo.fcMyPageInfo.url) {
      return true
    }
    return false
  }

  if (isInvalidLocationState(location.state)) {
    throw new MBMemberError('InvalidOperation')
  }

  return (
    <MembersPageTemplate
      hideFooterNavi={true}
      bucketInfo={locationState.bucketInfo}
    >

      <PageTitle>お支払いに関する情報変更完了</PageTitle>

      <StepGuide activity={'edit'} current={'complete'}/>

      <CompleteMessageContent
        title={'次回契約のお支払いに関する情報'}
        topMessage={'次回のお支払いに関する情報'}
        nextContractStartDate={locationState.nextContractStartDate}
        onCvsSelectLinkClick={(): void => handleCvsSelectLinkClick()}
      />

      <Spacer mt={'30px'}>
        <PIMPageActions>
          <ExternalLinkButton
            label={`${locationState.bucketInfo.fcMyPageInfo.name ?? ''}に移動する`}
            url={locationState.bucketInfo.fcMyPageInfo.url}
          />
        </PIMPageActions>
      </Spacer>

    </MembersPageTemplate>
  )
}
